<script lang="ts">
  import { type AuthContext } from "$src/infrastructure/accounts/AuthContext";
  import { ContextTokens } from "$src/presentation/contexts/ContextTokens";
  import MainTemplate from "$src/presentation/main/main-template.svelte";
  import { getContext } from "svelte";
  import NewProjectCard from "./components/new-project-card.svelte";

  let { activeGroupStore }: AuthContext = getContext(ContextTokens.Auth);

</script>
{#if $activeGroupStore?.groupStoreId && $activeGroupStore.stores.length > 0}
  <MainTemplate isEmbedded={false}>
    <NewProjectCard groupStoreId={$activeGroupStore.groupStoreId} stores={$activeGroupStore.stores} />
  </MainTemplate>
{/if}
